<template>
  <general-layout>
    <b-container>
      <b-row>
        <b-col sm="12">
          <b-alert
            :show="isShowUnauthenticatedAlert"
            dismissible
            variant="danger"
            @dismissed="isShowUnauthenticatedAlert = false">
            {{ $t('status.error.not_log_in') }}
          </b-alert>
          <b-alert
            :show="isShowLogoutAlert"
            dismissible
            variant="success"
            @dismissed="isShowLogoutAlert = false">
            {{ $t('status.success.log_out') }}
          </b-alert>
        </b-col>
        <b-col sm="10" offset-sm="1" class="px-0">
          <div id="authcore-sign-in-widget"></div>
        </b-col>
      </b-row>
    </b-container>
  </general-layout>
</template>

<script>
import { AuthCoreWidgets } from 'authcore-js'

import store from '@/store'

import GeneralLayout from '@/components/GeneralLayout.vue'

export default {
  name: 'SignIn',
  components: {
    GeneralLayout
  },

  props: {
    isShowUnauthenticatedAlert: {
      type: Boolean,
      default: false
    },
    isShowLogoutAlert: {
      type: Boolean,
      default: false
    },
    successRedirectUrl: {
      type: String
    }
  },

  data () {
    return {}
  },

  computed: {},

  watch: {},

  created () {},
  mounted () {
    const webUrl = new URL('/web/', document.location)
    // eslint-disable-next-line no-new
    new AuthCoreWidgets.Login({
      clientId: 'management',
      container: 'authcore-sign-in-widget',
      internal: true,
      successRedirectUrl: webUrl.toString(),
      onSuccess: this.onSuccessCallback,
      onLoaded: this.onLoadedCallback,
      setRefreshToken: true
    })
  },
  updated () {},
  destroyed () {},

  methods: {
    async onSuccessCallback (data) {
      const { action, access_token: accessToken } = data
      if (action === 'register' || action === 'login') {
        await store.dispatch('client/updateAccessToken', {
          accessToken: accessToken,
          refreshPage: true
        })
        await Promise.all([
          store.dispatch('currentUser/permissions/list'),
          store.dispatch('currentUser/get')
        ])
      }
    }
  }
}
</script>

<style>
iframe {
  width: 100%;
  height: 650px;
  border: 0px;
  overflow: hidden;
}
</style>
